// extracted by mini-css-extract-plugin
module.exports = {"mosaic":"mobilstauletes_mosaic__6VwLc","imatgeApp":"mobilstauletes_imatgeApp__x30W5","itemApp":"mobilstauletes_itemApp__18bnC","markets":"mobilstauletes_markets__McNez"};